import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you use the manual flow, make sure you add the `}<inlineCode parentName="p">{`primerDidTokenizePaymentMethod(_:decisionHandler:)`}</inlineCode>{` delegate function of `}<inlineCode parentName="p">{`PrimerDelegate`}</inlineCode>{`, create a payment on your backend and call the `}<inlineCode parentName="p">{`decisionHandler`}</inlineCode>{` of the delegate function once you receive your backend\\'s response.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      